export const COMMON_AJAX_DELAY    = 500;
export const RESIZE_HANDLER_DElAY = 300;
export const IMAGE_URL_STUB       = '/theme/fast/img/ll.png';
export const IMAGE_LOADING        = '/theme/fast/img/ajax-loader.gif';
export const CSRF_TOKEN_NAME      = 'ci_cst';

// точки слома согласно css-сетке
export const BREAKPOINTS = {
    SM: 577,
    MD: 769,
    LG: 993,
    XL: 1200,
    XXL: 1560,
};

export const DEFAULT_GLIDER_CLASSES = {
    direction: {
        ltr: 'slider_ltr',
        rtl: 'slider_rtl'
    },
    slider: 'slider_slider',
    carousel: 'slider_carousel',
    swipeable: 'slider_swipeable',
    dragging: 'slider_dragging',
    cloneSlide: 'slider__slide_cloned',
    activeNav: 'slider__bullet_active',
    activeSlide: 'slider__slide_active',
    disabledArrow: 'slider__arrow_disabled',
};
